import actionTypes from "./actionTypes";
import api from "./api";
import { error, info } from "App/popupMessage";
import locale from "./actionCreators.locale";
export default {
    saveFile: ({ data, onCompleted, onRejected }) => ({
        type: actionTypes.SAVE_FILE,
        payload: {
            promise: () => api.saveFile(data)
        },
        completed: (_, { payload }) => {
            onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted(payload);
        },
        rejected: (dispatch, { payload }) => {
            dispatch(error(locale.SAVE_FILE_ERROR));
            onRejected === null || onRejected === void 0 ? void 0 : onRejected(payload);
        }
    }),
    voiceRecognition: ({ data, onCompleted, onRejected }) => ({
        type: actionTypes.API_VOICE_RECOGNITION,
        payload: {
            promise: () => api.voiceRecognition(data)
        },
        completed: (dispatch, { payload }) => {
            if ((payload === null || payload === void 0 ? void 0 : payload.length) === 0) {
                dispatch(info(locale.VOICE_RECOGNITION_EMPTY));
            }
            onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted(payload);
        },
        rejected: (dispatch, { payload }) => {
            dispatch(error(locale.SAVE_FILE_ERROR));
            onRejected === null || onRejected === void 0 ? void 0 : onRejected(payload);
        }
    })
};
